module.exports = __webpack_public_path__ + "media/images/sebastiao_triste-236dccf0a4066e0155f3183b209edab0.png";